import React, { FunctionComponent } from "react"
import { Button, Modal, Spinner } from "react-bootstrap"
import ratmCrud from "../../utils/RATMCrud"
import ratmService from "../../utils/RATMService"
import "./RoleManagementDeleteRAA.css"

const RoleManagementDeleteRAA: FunctionComponent<{}> = () => {

    const { deletePortalRolesAndAssignments } = ratmCrud
    const { state, manageState } = ratmService
    const { deleteRoleId, busyId } = state

    return (
        <div className="RoleManagementDeleteRAA">
            <Modal
                id="g647f247f46b4a71affaa0e7e3d27755"
                show={true}
                backdrop="static"
                keyboard={true}
                centered={true}
                size="sm"
            >
                <Modal.Header>
                    <div className="RoleManagementDeleteRAAModalHeader">
                        <span className="material-icons">warning</span>
                        <p>Please confirm</p>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="RoleManagementDeleteRAAModalModalBody">
                        <p>This operation will also remove roles from any user or template.</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="RoleManagementDeleteRAAModalModalFooter">
                        <Button variant="secondary" onClick={() => manageState([{ key: "deleteRoleId", value: -1 }])}>Back</Button>
                        {
                            busyId !== 3 &&
                            <Button variant="danger" onClick={() => deletePortalRolesAndAssignments(deleteRoleId)}>Delete</Button>
                        }
                        {
                            busyId === 3 &&
                            <Spinner className="fc5773659914f0f94dbaebcf0a3ce56" animation="border" />
                        }
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default RoleManagementDeleteRAA